import { api } from './base';

import { MutationArg } from 'v2/types';
import { SlideModel } from 'v2/types/SlideModel';
import { StatisticModel } from 'v2/types/StatisticModel';
import { SWRKeyValue } from 'v2/types/swr';

export const mainScreenSettingsService = {
  getStatistic(): Promise<StatisticModel> {
    return api.get('admin/statistic').json();
  },

  updateStatistic(
    _key: string,
    { arg }: MutationArg<Pick<StatisticModel, 'totalPrizesAmount'>>
  ): Promise<StatisticModel> {
    return api.put('admin/statistic', { json: arg }).json();
  },

  getSlides(): Promise<SlideModel[]> {
    return api.get('v1/admin/presentation-slide').json();
  },

  createSlide(_key: string, { arg }: MutationArg<Omit<SlideModel, 'id' | 'order'>>): Promise<SlideModel> {
    return api.post('v1/admin/presentation-slide', { json: arg }).json();
  },

  updateSlide(
    [_key, slideId]: SWRKeyValue,
    { arg }: MutationArg<Omit<SlideModel, 'id' | 'order'>>
  ): Promise<SlideModel> {
    return api.put(`v1/admin/presentation-slide/${slideId}`, { json: arg }).json();
  },

  changeSlideOrder(_key: string, { arg }: MutationArg<Pick<SlideModel, 'id' | 'order'>[]>): Promise<SlideModel[]> {
    return api.patch('v1/admin/presentation-slide/order', { json: arg }).json();
  },

  deleteSlide([_key, slideId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/presentation-slide/${slideId}`).json();
  },
};
